<template>
  <div>
    <el-drawer
      :title="`Cliente: ${data.CustomerName}`"
      :visible.sync="drawer"
      size="70%"
      v-bind="$attrs"
      :append-to-body="true"
      @closed="onDrawerClose"
    >
      <el-container>
        <el-main>
          <el-row>
            <el-col>
              <div class="card-base card-shadow--medium">
                <rabbey-table-3
                  ref="tableContactsWithOrWithoutApp"
                  class="table"
                  :max-height="700"
                  v-loading="loading"
                  :columns="columnasContacts"
                  :data.sync="ResultadoContactsDetalle"
                  :page-sizes="[10, 30, 50, 100, 500, 1000]"
                />
              </div>
            </el-col>
          </el-row>
        </el-main>
      </el-container>
    </el-drawer>
  </div>
</template>

<script>
import ColorTagsinLineFormatter from "@/components/functionals/ColorTagsinLineFormatter";
import CompanyFormatter from "@/components/functionals/CompanyFormatter.vue";
import { formatPhoneNumber } from "@/utils.js";

export default {
  data() {
    return {
      loading: false,
      drawer: false,
      data: {},
      ResultadoContactsDetalle: [],
      columnasContacts: [
        {
          prop: "ContactCode",
          label: "Codigo Contacto",
          sortable: true,
          width: 170,
          align: "center",
          fixed: true
        },
        {
          prop: "ContactName",
          label: "Nombre",
          sortable: true,
          width: 220,
          align: "center"
        },
        {
          prop: "ContactPhone",
          label: "Telefono",
          sortable: true,
          width: 150,
          align: "center",
          formatter: (row) => formatPhoneNumber(row.ContactPhone)
        },
        {
          prop: "ContactEmail",
          label: "Email",
          sortable: true,
          width: 240
        },

        {
          prop: "UsoApp",
          label: "App",
          sortable: true,
          width: 100,
          align: "center",
          formatter: ColorTagsinLineFormatter
        },

        {
          prop: "companyCode",
          label: "Compañia",
          sortable: true,
          width: 150,
          align: "center",
          formatter: CompanyFormatter
        },

        {
          prop: "EstadoProtalWeb",
          label: "Estado en el portal",
          sortable: true,
          width: 190,
          align: "center",
          formatter: ColorTagsinLineFormatter
        }
      ]
    };
  },

  methods: {
    show(data, type) {
      this.data = data;

      switch (type) {
        case "CantContactsWithApp":
          this.ResultadoContactsDetalle = data.ContactsWithApp;

          break;

        case "CantContactsWithoutApp":
          this.ResultadoContactsDetalle = data.ContactsWithoutApp;

          break;
        case "CantContactPortalWebActive":
          this.ResultadoContactsDetalle = data.ContactPortalWebActive;

          break;

        case "CantContactPortalWebInactive":
          this.ResultadoContactsDetalle = data.ContactPortalWebInactive;

          break;

        case "CantTotalContacts":
          this.ResultadoContactsDetalle = data.TotalContacts;

          break;
      }
      let ContactArray = [];
      this.ResultadoContactsDetalle.forEach((Contacto) => {
        let usoapp = Boolean;

        if (Contacto.LoginQTY > 0) {
          usoapp = true;
        } else {
          usoapp = false;
        }
        if (Contacto.EstadoProtalWeb == null) {
          Contacto.EstadoProtalWeb = false;
        }

        ContactArray.push({
          UsoApp: usoapp,
          ...Contacto
        });
      });

      this.ResultadoContactsDetalle = ContactArray;
      this.drawer = true;
    },

    onDrawerClose() {
      this.ResultadoContactsDetalle = [];
    }
  }
};
</script>

<style scoped></style>
